import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "n-icon-select-all",
  "use": "n-icon-select-all-usage",
  "viewBox": "0 0 16 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 10\" id=\"n-icon-select-all\"><path fill=\"currentColor\" d=\"M11.362.924a.714.714 0 0 1 .06.942l-.06.068L4.22 9.077a.714.714 0 0 1-.943.059l-.067-.06L.352 6.22a.714.714 0 0 1 .943-1.07l.067.06 2.352 2.352L10.352.924a.714.714 0 0 1 1.01 0Zm4.286 0a.714.714 0 0 1 .06.942l-.06.068-7.143 7.143a.714.714 0 0 1-1.07-.943l.06-.068L14.638.924a.714.714 0 0 1 1.01 0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol